import React, { useState } from "react";
import { UncontrolledTooltip } from "Components/ReactstrapSlim";
import uniqueId from "lodash/uniqueId";
import * as Icons from "Components/Icons";

interface InstantBookBadgeProps {
   container?: HTMLElement | string; 
}

export const InstantBookBadge: React.FC<InstantBookBadgeProps> = ({ container }) => {
   const [id] = useState(() => uniqueId("instant-"));
   return <div className="instant-book-badge" id={id}>
      <Icons.Lightning />
      <UncontrolledTooltip container={container} placement="top" target={id} fade={false}>
         Book this space instantly!
      </UncontrolledTooltip >
   </div>
}